import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cancellationReasons: {},
  equipmentUrls: {},
};

const transportSlice = createSlice({
  name: "transport",
  initialState,
  reducers: {
    setCancellationReasons(state, action) {
      state.cancellationReasons = action.payload;
    },
    setEquipmentUrls(state, action) {
      state.equipmentUrls = action.payload;
    },
  },
});

export const { setCancellationReasons,setEquipmentUrls } = transportSlice.actions;
export default transportSlice.reducer;
